module.exports = __webpack_public_path__ + "img/umbrella.aa296687.gif";